import { theme } from "@tm/utility/global";
import styled from "styled-components";
import { cardHeaderTitleStyle } from "./CancelPolicyStepCards.style";

export const paymentTitleStyle = cardHeaderTitleStyle;

export const paymentTotalLabelStyle = {
  color: theme.blackText,
  fontSize: "14px",
  lineHeight: "18px",
  fontWeight: 700,
};

export const paymentTotalValueStyle = {
  ...paymentTotalLabelStyle,
  textAlign: "right" as const,
  whiteSpace: "nowrap" as const,
};

export const paymentBreakupLabelStyle = {
  color: theme.greyText,
  fontSize: "12px",
  lineHeight: "16px",
  fontWeight: 400,
};

export const paymentBreakupValueStyle = {
  ...paymentBreakupLabelStyle,
  textAlign: "right" as const,
  whiteSpace: "nowrap" as const,
};

export const PaymentDetailsHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 16px 0;
`;

export const PaymentSectionWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
`;

export const PaymentTotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
`;

export const PaymentBreakupList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PaymentBreakupItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
`;
